import { defineSlotRecipe } from '@chakra-ui/react';

export const toolsSlotRecipe = defineSlotRecipe({
  className: 'ac-tools',
  slots: ['root', 'group', 'button', 'groupbutton'],
  base: {
    root: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'flex-start',
      boxShadow: '10px 10px 15px 0px rgba(17, 17, 17, 0.1)',
      rounded: 'main',

      '& svg': {
        flexShrink: 0,
      },
    },
    button: {
      width: '60px',
      height: '60px',
      backgroundColor: 'grey.dark.2',
      padding: '0px',
      border: 'none',
      color: 'white',

      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,

      '& svg': {
        '& path, rect': {
          transitionProperty: 'stroke',
          transitionDuration: 'fast',
          transitionTimingFunction: 'linear',
        },
      },

      _hover: {
        color: 'halton.blue',

        '& svg path': {
          stroke: 'halton.blue',
        },
        '& svg rect': {
          stroke: 'halton.blue',
        },
      },

      _active: {
        color: 'white !important',

        '& svg': {
          '& path, rect': {
            stroke: 'white !important',
          },
        },

        _first: {
          background: 'linear-gradient(135deg, #76C6FF 2.89%, #2996DF 74.79%)',
        },
        _notFirst: {
          background: 'linear-gradient(225deg, #76C6FF 2.89%, #2996DF 74.79%)',
        },
      },

      _selected: {
        color: 'white !important',

        _first: {
          background: 'linear-gradient(135deg, #76C6FF 2.89%, #2996DF 74.79%)',
        },
        _notFirst: {
          background: 'linear-gradient(45deg, #76C6FF 2.89%, #2996DF 74.79%)',
        },

        '& svg': {
          '& path, rect': {
            stroke: 'white !important',
          },
        },
      },
    },
    group: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',

      minW: '60px',
      minH: '60px',

      flexShrink: 0,

      overflow: 'hidden',

      width: '60px',
      height: '60px',
      background: 'grey.dark.2',

      padding: '0px',
      border: 'none',
      color: 'white',

      transitionDuration: 'fast',
      transitionTimingFunction: 'ease-in-out',

      '& > svg': {
        width: '30px',
        height: '30px',
        margin: '15px',

        '& path, rect': {
          transitionDuration: 'fast',
          transitionTimingFunction: 'linear',
          transitionProperty: 'stroke',
        },
      },

      _hover: {
        color: 'halton.blue',

        '& svg path': {
          stroke: 'halton.blue',
        },
        '& svg rect': {
          stroke: 'halton.blue',
        },
      },

      _active: {
        color: 'white !important',

        '& svg': {
          '& path, rect': {
            stroke: 'white !important',
          },
        },

        _first: {
          background: 'linear-gradient(135deg, #76C6FF 2.89%, #2996DF 74.79%)',
        },
        _notFirst: {
          background: 'linear-gradient(225deg, #76C6FF 2.89%, #2996DF 74.79%)',
        },
      },

      '& > :not(:first-child)': {
        opacity: 0,
      },

      _open: {
        background: 'linear-gradient(135deg, #2AA6FF 2.89%, #0D5F96 74.79%)',

        '& > svg': {
          '& path, rect': {
            transition: 'none',
          },
        },

        '& svg path': {
          stroke: '{colors.grey.light.1}',
        },

        _hover: {
          color: 'white',

          '& svg path': {
            stroke: '{colors.grey.light.1}',
          },
          '& svg rect': {
            stroke: '{colors.grey.light.1}',
          },
        },

        '& > :not(:first-child)': {
          opacity: 1,
        },
      },
    },
    groupbutton: {
      rounded: 'small',
      border: '1px solid {colors.grey.light.0/30}',
      height: '40px',
      marginRight: '10px',
      padding: '10px',
      backgroundColor: 'transparent',
      color: 'white',
      fontFamily: 'Roboto, sans-serif',
      fontSize: '12px',
      fontWeight: 400,
      letterSpacing: '0.12px',

      flexShrink: 0,

      transitionProperty: 'background, border, opacity',
      transitionDuration: 'fast',
      transitionTimingFunction: 'linear',

      _hover: {
        border: '1px solid {colors.grey.light.0/60}',
      },

      _last: {
        marginRight: '16px',
      },

      _disabled: {
        color: 'grey.dark.1',
        background: 'linear-gradient(rgba(255,255,255,0.05)), transparent',
      },

      _selected: {
        backgroundColor: 'grey.dark.2',
        border: '1px solid {colors.grey.dark.2} !important',

        _disabled: {
          background: 'linear-gradient(rgba(255,255,255,0.05)), {grey.dark.2}',
        },
      },
    },
  },
  variants: {
    position: {
      bottom: {
        root: {
          left: '50%',
          transform: 'translateX(-50%)',
          bottom: '60px',
        },
      },
      left: {
        root: {
          top: '50%',
          transform: 'translateY(-50%)',
          left: '60px',
        },
      },
      right: {
        root: {
          top: '50%',
          transform: 'translateY(-50%)',
          right: '60px',
        },
      },
      top: {
        root: {
          left: '50%',
          transform: 'translateX(-50%)',
          top: '60px',
        },
      },
    },
    variant: {
      horizontal: {
        root: {
          flexDir: 'row',
          '& > :first-child': {
            borderLeftRadius: 'main',
          },
          '& > :last-child': {
            borderRightRadius: 'main',
          },
        },
        button: {
          _notLast: {
            borderRight: '1px solid {colors.grey.dark.1}',
          },
        },
        group: {
          flexDir: 'row',
          transitionProperty: 'width',
          '&:not(:last-child)': {
            borderRight: '1px solid {colors.grey.dark.1}',
          },
        },
      },
      vertical: {
        root: {
          flexDir: 'column',
          '& > :first-child': {
            borderTopRadius: 'main',
          },
          '& > :last-child': {
            borderBottomRadius: 'main',
          },
        },
        button: {
          _notLast: {
            borderBottom: '1px solid {colors.grey.dark.1}',
          },
        },
        group: {
          flexDir: 'column',
          transitionProperty: 'height',
          '&:not(:last-child)': {
            borderRight: '1px solid {colors.grey.dark.1}',
          },
        },
      },
    },
    groupStyle: {
      room: {
        group: {
          _open: {
            background: 'linear-gradient(135deg, #2AA6FF 2.89%, #0D5F96 74.79%)',
          },
        },
      },
      zone: {
        group: {
          _open: {
            background: 'linear-gradient(225deg, #76C6FF 2.89%, #2996DF 74.79%)',
          },
        },
      },
    },
  },
  compoundVariants: [],
  defaultVariants: {
    position: 'bottom',
    variant: 'horizontal',
    groupStyle: 'room',
  },
});
